"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (htmlStr) {
    return {
        __html: htmlStr
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/react/createMarkup.js
// module id = 467
// module chunks = 0